import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled.div`
  width: min(26rem, calc(100% - 2.4rem));
  height: 6.2rem;
  border-radius: 1000px;
  padding: 0.4rem;
  display: flex;
  position: absolute;
  bottom: env(safe-area-inset-bottom);
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  overflow: hidden;
  isolation: isolate;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.4),
    0 2px 8px rgba(0, 0, 0, 0.3),
    inset 0 0.5px 0 rgba(255, 255, 255, 0.1);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: 0.5px solid rgba(255, 255, 255, 0.08);
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.03) 22%, rgba(0, 0, 0, 0.22) 100%),
      rgba(7, 7, 9, 0.23);
    backdrop-filter: blur(36px) saturate(150%) brightness(0.66);
    -webkit-backdrop-filter: blur(36px) saturate(150%) brightness(0.66);
    z-index: 0;
    pointer-events: none;
    transform: translateZ(0);
    backface-visibility: hidden;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.14),
      inset 0 -1px 0 rgba(255, 255, 255, 0.04);
  }
`;

export const NavigationItem = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  position: relative;
  z-index: 1;

  a {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-decoration-line: none;
    position: relative;
    border-radius: 100px;
    overflow: hidden;
    svg {
      color: #fff;
    }
  }
`;

export const NavigationContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  isolation: isolate;
`;

export const ActiveBackground = styled(motion.div)`
  position: absolute;
  top: 0.4rem;
  bottom: 0.4rem;
  left: 0.4rem;
  width: calc(50% - 0.4rem);
  border-radius: 1000px;
  border: 0.5px solid rgba(255, 255, 255, 0.12);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.035) 100%),
    rgba(14, 14, 16, 0.14);
  backdrop-filter: blur(19px) saturate(145%) brightness(0.8);
  -webkit-backdrop-filter: blur(19px) saturate(145%) brightness(0.8);
  box-shadow:
    0 2px 12px rgba(0, 0, 0, 0.25),
    inset 0 0.5px 0 rgba(255, 255, 255, 0.15);
  transform: translateZ(0);
  backface-visibility: hidden;
  will-change: backdrop-filter;
  pointer-events: none;
`;

export const Text10ExtraBold = styled.span`
  font-size: 1rem;
  font-weight: 800;
  color: #fff;
`;
